import { useEffect, useState } from 'react';

import { useGlobalDialog } from "../../../Store/DialogManager";

import { useSnackbar } from "notistack";
import styled from 'styled-components';

import { useVendorsHook } from '../../../Hooks/Maintenance/Vendors/vendorsHooks';

import { Vendor, AddEditVendorModalInterface } from '../../../Models/Maintenance/Vendors/Vendor';

import RequiredParametersHelper from '../../../Utilities/Helpers/RequiredParametersHelper';
import RequiredFieldHelper from '../../../Utilities/Helpers/RequiredFieldHelper';
import QueryBuilderHelper from '../../../Utilities/Helpers/QueryBuilderHelper';

import { ButtonType } from '../../../Utilities/Enums/ButtonTypeEnum';
import { VendorField } from '../../../Utilities/Enums/ParametersEnum';
import { CachingEnum } from '../../../Utilities/Enums/CachingEnum';

import CustomButton from '../../../CustomViews/Elements/CustomButton';
import FormTextField from '../../../CustomViews/Elements/FormTextField';
import AutoCompleteDropdown from '../../../CustomViews/Elements/AutoCompleteDropdown';
import CompanyDropdown from '../../../CustomViews/Elements/AutoComplete/CompanyDropdown';

const ModalContentContainer = styled.div <{ $darkMode?: boolean; }>`
    display: grid;
    grid-template-columns: 1fr;
    gap: 10px;
    width: 30vw;
`;

export default function AddEditVendorModal(props: AddEditVendorModalInterface) {
    let { openAddEditModal, setopenAddEditModal, selectedVendor, setselectedVendor } = props;
    const { enqueueSnackbar } = useSnackbar();
    const { setDialogContent, setOpenGlobalDialog } = useGlobalDialog();
    let requiredFields = RequiredParametersHelper.vendors();

    //Use States
    let [errorMessages, setErrorMessages]: any = useState({});
    const [queryStr, setQueryStr] = useState({
        pageSize: QueryBuilderHelper.DefaultPageSizeValue(),
        pageNumber: QueryBuilderHelper.DefaultPageNumValue(),
        searchString: QueryBuilderHelper.DefaultSearchValue(),
    });

    const q_queryKey = [CachingEnum.VENDOR, queryStr]
    const { DropdownData, dropdownFetchStatus, createVendor, editVendorById } = useVendorsHook(q_queryKey, queryStr, false);


    const codeProps = {
        name: VendorField.CODE,
        title: 'Code',
        fieldValue: selectedVendor?.[VendorField.CODE] ?? "",
        type: 'text',
        required: requiredFields?.find((field: any) => field.keyName == VendorField.CODE)?.keyName != null,
        errorMessages: errorMessages,
        handleOnChange: (selectedValue: any) => {
            if(setselectedVendor) {
                setselectedVendor(prev => ({ ...prev, [VendorField.CODE]: selectedValue }));
            }
        },
    },
        nameProps = {
            name: VendorField.NAME,
            title: 'Name',
            fieldValue: selectedVendor?.[VendorField.NAME] ?? "",
            type: 'text',
            required: requiredFields?.find((field: any) => field.keyName == VendorField.NAME)?.keyName != null,
            errorMessages: errorMessages,
            handleOnChange: (selectedValue: any) => {
                if(setselectedVendor) {
                    setselectedVendor(prev => ({ ...prev, [VendorField.NAME]: selectedValue }));
                }
            },
        },
        companyProps = {
            name: VendorField.COMPANY_PUBLIC_IDS,
            title: 'Company',
            fieldValue: selectedVendor?.[VendorField.COMPANY_PUBLIC_IDS] ?? [],
            required: requiredFields?.find((field: any) => field.keyName == VendorField.COMPANY_PUBLIC_IDS)?.keyName != null,
            multiple: true,
            errorMessages: errorMessages,
            handleOnChange: (selectedValue: any) => {
                if(setselectedVendor) {
                    setselectedVendor(prev => ({
                        ...prev,
                        [VendorField.COMPANY_PUBLIC_IDS]: selectedValue?.map((item: any) => { return item.id }) ?? [],
                        [VendorField.COMPANIES]: selectedValue ?? [],
                    }));
                }
            },
        },
        statusProps = {
            name: VendorField.STATUS,
            title: 'Status',
            fieldValue: selectedVendor?.[VendorField.STATUS] ?? "",
            options: DropdownData?.[CachingEnum.STATUS_LIST] ?? [],
            isLoadingDropdown: dropdownFetchStatus ?? false,
            required: requiredFields?.find((field: any) => field.keyName == VendorField.STATUS)?.keyName != null,
            errorMessages: errorMessages,
            handleOnChange: (selectedValue: any) => {
                if(setselectedVendor) {
                    setselectedVendor((prev: any) => ({ ...prev, [VendorField.STATUS]: selectedValue?.id ?? '' }));
                }
            },
        };

    //Event Handlers
    const onCloseDialog = async (e: any = null) => {
        if(e) {
            e.preventDefault();
        }

        if(setopenAddEditModal) {
            setopenAddEditModal(false);
        }

        if(setselectedVendor) {
            setselectedVendor(new Vendor());
        }

        setOpenGlobalDialog(false);
    }

    useEffect(() => {
        if(openAddEditModal) {
            setDialogContent({
                title: (!selectedVendor?.[VendorField.PUBLIC_ID] ? "Add" : "Edit") + " Vendor",
                clearDialog: onCloseDialog,
                onCloseDialog: onCloseDialog,
                actionButtons: renderActionButtons(),
                children: renderDialogContent(),
            });
        }
    }, [openAddEditModal, selectedVendor, errorMessages]);

    const handleSubmit = async () => {
        let _validateForm = RequiredFieldHelper.validateForm(requiredFields, selectedVendor, errorMessages, setErrorMessages, enqueueSnackbar);

        if (_validateForm?.hasError) { return true; }

        let _success: boolean = false;

        if(!selectedVendor?.[VendorField.PUBLIC_ID]) {
            let createResponse = await createVendor(JSON.stringify(selectedVendor));
            
            _success = createResponse?.isSuccess ?? false;
        } else {
            let editResponse = await editVendorById(selectedVendor?.[VendorField.PUBLIC_ID], JSON.stringify(selectedVendor));
            
            _success = editResponse?.isSuccess ?? false;
        }

        if(_success) {
            onCloseDialog();
        }
    }

    //Rendering Functions
    const renderActionButtons = () => {
        return <>
            <CustomButton
                btnType={ButtonType.CANCEL}
                title='Close'
                onClick={(e: any) => {
                    onCloseDialog(e);
                }} />

            <CustomButton
                btnType={ButtonType.SUCCESS}
                title='Save'
                onClick={(e: any) => {
                    handleSubmit();
                }} />
        </>
    }

    const renderDialogContent = () => {
        return <ModalContentContainer>
            <FormTextField {...codeProps} />
            <FormTextField {...nameProps} />
            <CompanyDropdown {...companyProps} />
            <AutoCompleteDropdown {...statusProps} />
        </ModalContentContainer>
    }

    return <></>
}